var _rect, _path, _circle, _text, _rect2, _text2, _text3, _circle2, _text4, _rect3, _text5, _text6, _circle3, _text7, _rect4, _text8, _text9, _circle4, _text0, _rect5, _text1, _text10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFleetcoreImplementationResponsibleIntelligencePathwayMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 360,
    height: 660,
    viewBox: "0 0 360 660",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "FleetCore mobile implementation pathway") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 360,
    height: 660,
    rx: 28,
    fill: "#FFFFFF",
    stroke: "#D2E1F2",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52 80V578",
    stroke: "#D2E1F2",
    strokeWidth: 3,
    strokeDasharray: "5 8"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 52,
    cy: 80,
    r: 19,
    fill: "#087CFF"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 52,
    y: 86,
    fill: "#fff",
    textAnchor: "middle",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 11,
    fontWeight: 850
  }, "01")), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 86,
    y: 42,
    width: 238,
    height: 92,
    rx: 18,
    fill: "#F4F8FD",
    stroke: "#D2E1F2"
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 108,
    y: 76,
    fill: "#087CFF",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10,
    fontWeight: 850,
    letterSpacing: 1.2
  }, "CONFIGURE")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 108,
    y: 107,
    fill: "#07152A",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 750
  }, "Roles, assets and evidence rules")), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 52,
    cy: 243,
    r: 19,
    fill: "#FF2775"
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 52,
    y: 249,
    fill: "#fff",
    textAnchor: "middle",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 11,
    fontWeight: 850
  }, "02")), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 86,
    y: 205,
    width: 238,
    height: 92,
    rx: 18,
    fill: "#F4F8FD",
    stroke: "#D2E1F2"
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 108,
    y: 239,
    fill: "#FF2775",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10,
    fontWeight: 850,
    letterSpacing: 1.2
  }, "PILOT")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 108,
    y: 270,
    fill: "#07152A",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 750
  }, "Focused fleet and real shifts")), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 52,
    cy: 406,
    r: 19,
    fill: "#087CFF"
  })), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 52,
    y: 412,
    fill: "#fff",
    textAnchor: "middle",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 11,
    fontWeight: 850
  }, "03")), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 86,
    y: 368,
    width: 238,
    height: 92,
    rx: 18,
    fill: "#F4F8FD",
    stroke: "#D2E1F2"
  })), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 108,
    y: 402,
    fill: "#087CFF",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10,
    fontWeight: 850,
    letterSpacing: 1.2
  }, "VALIDATE")), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 108,
    y: 433,
    fill: "#07152A",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 750
  }, "Thresholds, reports and workflow")), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 52,
    cy: 569,
    r: 19,
    fill: "#FF2775"
  })), _text0 || (_text0 = /*#__PURE__*/React.createElement("text", {
    x: 52,
    y: 575,
    fill: "#fff",
    textAnchor: "middle",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 11,
    fontWeight: 850
  }, "04")), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 86,
    y: 531,
    width: 238,
    height: 92,
    rx: 18,
    fill: "#F4F8FD",
    stroke: "#D2E1F2"
  })), _text1 || (_text1 = /*#__PURE__*/React.createElement("text", {
    x: 108,
    y: 565,
    fill: "#FF2775",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10,
    fontWeight: 850,
    letterSpacing: 1.2
  }, "SCALE")), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 108,
    y: 596,
    fill: "#07152A",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 13,
    fontWeight: 750
  }, "Expand when the process is ready")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFleetcoreImplementationResponsibleIntelligencePathwayMobile);
export default __webpack_public_path__ + "static/media/fleetcore-implementation-responsible-intelligence-pathway-mobile.1c9f9fef869eb8412c6525a2f2fba618.svg";
export { ForwardRef as ReactComponent };